import { Pipe, PipeTransform } from '@angular/core';
import { DebtorManagement } from '../models/debtorManagement.model';
@Pipe({
  name: 'debtorNameFilter'
})
export class DebtorNameFilterPipe implements PipeTransform {
  transform(items: DebtorManagement[], searchText: string): any[] {
    if (!items) return [];
    if (!searchText) return items;
    searchText = searchText.toLowerCase();
    return items.filter(it => {

      return it.idDebtor.toString().toLowerCase().includes(searchText);
    });
  }
}
